<template>
  <router-view/>
</template>

<style lang="scss">
  // Import Main styles for this application
  @import '@/styles/bootstrap.scss';
  @import '@/styles/app.scss';
  // Dark theme last, so its overrides land after everything they override.
  // Imported HERE and not from inside app.scss: p-table.vue imports app.scss a
  // second time, so anything added there is compiled into the bundle twice.
  @import '@/styles/app/themes/dark';
</style>
<script>
  window.csmWidgetSettings = {
    widgetId: "e5e5730b-b9b4-4f12-9e90-9d4fd3a4f88c",
    site: "nebook.atlassian.net",
    cloudId: "b39dfb5b-f0d8-48a9-9409-1c83c76987c7",
    // No floating bubble - the chat icon in Header.vue opens the chat panel via CSM('open')
    launcher: "none",
  };
  (function(){
    if (typeof window.CSM === "undefined") {
      var CSM = function(){CSM.__q__.push(arguments);};CSM.__q__=[];window.CSM=CSM;
      var l = function() {var s = document.createElement('script');s.type="text/javascript";s.async=true;s.src="https://nebook.atlassian.net/csm/widget/script.js?widgetId=e5e5730b-b9b4-4f12-9e90-9d4fd3a4f88c&site=nebook.atlassian.net&cloudId=b39dfb5b-f0d8-48a9-9409-1c83c76987c7";document.body.appendChild(s);}
      if(document.readyState==="complete"){l();}else{window.addEventListener('load',l);}
    }
  }())

  // The widget defaults to the maximum z-index; sit below Bootstrap modals (1050+) and toasts
  window.CSM('update', { zIndex: 1040 });
</script>